import React from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'

import { Btn, HeaderText, OcorrenciasDropdown } from '../../../../../components'
import { tableCellCentered } from '../../../../../assets/js/styles'
import { getResumoSeparacaoQuantidadeFracionada } from '../../ResumoSeparacao/quantity-fracionada.helper'

function ApuracaoOcorrencias({
  titulo,
  itens,
  selecionadas,
  ocorrencias,
  disabled,
  mensagemVazia,
  onChange,
  onAssociar,
}) {
  if (!itens.length) return <p>{mensagemVazia}</p>

  const renderQuantidadeCell = (item, type) => {
    const quantidade = getResumoSeparacaoQuantidadeFracionada(item, 'quantidade')
    const value = type === 'volume' ? quantidade.volumeText : quantidade.unitsText
    const label = type === 'volume' ? quantidade.volumeLabel : quantidade.unitsLabel
    const defaultLabel = type === 'volume' ? 'Vol.' : 'Frac.'

    return (
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontWeight: 600 }}>{value}</div>
        {label !== defaultLabel ? (
          <div style={{ fontSize: '0.72rem', marginTop: 2 }}>{label}</div>
        ) : null}
      </div>
    )
  }

  const codigoColWidth = Math.max(
    130,
    Math.max(...itens.map(i => (i.product_code || '').length)) * 9,
  )

  return (
    <div>
      <HeaderText>{titulo}</HeaderText>
      <div style={{ marginTop: 10, marginBottom: 25 }}>
        <Btn disabled={disabled} onClick={onAssociar}>
          Associar Ocorrência(s)
        </Btn>
      </div>
      <div className="main_container">
        <DataTable value={itens} style={{ tableLayout: 'fixed', width: '100%' }}>
          <Column
            field="product_code"
            header="Código"
            style={{
              ...tableCellCentered(codigoColWidth),
              whiteSpace: 'nowrap',
              overflow: 'hidden',
            }}
          />
          <Column
            field="product_name"
            header="Produto"
            style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
          />
          <Column
            header="Vol."
            style={tableCellCentered(110)}
            body={item => renderQuantidadeCell(item, 'volume')}
          />
          <Column
            header="Frac."
            style={tableCellCentered(110)}
            body={item => renderQuantidadeCell(item, 'units')}
          />
          <Column
            header="Ocorrência"
            style={tableCellCentered(320)}
            body={item => (
              <OcorrenciasDropdown
                disabled={disabled}
                style={{ width: '100%' }}
                optionLabel="name"
                value={selecionadas[item.id]}
                options={ocorrencias}
                appendTo={document.body}
                onChange={({ value }) => onChange(item.id, value)}
                placeholder="Selecione o Tipo de Ocorrência"
              />
            )}
          />
        </DataTable>
      </div>
    </div>
  )
}

export default ApuracaoOcorrencias
